import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { authService } from 'services/authService';

const PrivateRoute: React.FC = () => {
  const isGuest = localStorage.getItem("guestMode") === "true";
  if (!isGuest && !authService.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
};

export default PrivateRoute;
